module.exports = __webpack_public_path__ + "779162d93c12fc2fd1d25e1bb13ff38f.png";